<template>
  <div>
    <div class="mobile-download">
      <div class="logo">
        <svg slot="image" class="icon" aria-hidden="true">
          <!-- <use xlink:href="#icon-logo1"></use> -->
          <use xlink:href="#icon-daiwenzilogo"></use>
        </svg>
      </div>
      <div>
        <div class="title">Download SUPEREX</div>
        <div class="title-tip">
          <p>The Super Exchange app</p>
          <p>
            SuperEx's mission is to create a regulated and open financial
            platform for the world by leveraging blockchain technology.
          </p>
          <p>
            Our main services include cryptocurrency trading, derivatives
            trading and high-security storage. While also supporting more
            innovative services, such as DEFI, NFT, financial management,
            mining, stocks, etc.
          </p>
          <p>
            Everyone in the world deserves a safe, easy-to-use way to access
            digital currency markets.
          </p>
        </div>
        <div class="fotterBotton">
          <van-button class="button" type="default" v-if="isIOS" :disabled="!appStoreUrl" @click="handleClick(appStoreUrl)">
            <div slot="icon">
              <svg slot="image" class="icon" aria-hidden="true">
                <use xlink:href="#icon-ios1"></use>
              </svg>
            </div>
            App Store <em v-show="!appStoreUrl">(Reviewing)</em>
          </van-button>
          <van-button class="button" type="default" v-if="isIOS" :disabled="!TFLink" @click="handleClick(TFLink)">
            <div slot="icon">
              <svg slot="image" class="icon" aria-hidden="true">
                <use xlink:href="#icon-ios1"></use>
              </svg>
            </div>
            TestFlight <em v-show="!TFLink">(Reviewing)</em>
          </van-button>
          <van-button class="button" type="default" v-if="!isIOS" :disabled="!androidApk" @click="handleClick(androidApk)">
            <div slot="icon">
              <svg slot="image" class="icon" aria-hidden="true">
                <use xlink:href="#icon-anzhuo3"></use>
              </svg>
            </div>
            Android APK <em v-show="!androidApk">(Reviewing)</em>
          </van-button>
          <van-button class="button" type="default" v-if="!isIOS" :disabled="!googlePlayUrl" @click="handleClick(googlePlayUrl)">
            <div slot="icon">
              <svg slot="image" class="icon" aria-hidden="true">
                <use xlink:href="#icon-guge2"></use>
              </svg>
            </div>
            Google Play <em v-show="!googlePlayUrl">(Reviewing)</em>
          </van-button>
          <!--          <a
                      :href="appStoreUrl ? appStoreUrl : 'javascript:return false;'"
                      target="_blank"
                      class="button"
                      :class="{ disabledBtn: !appStoreUrl }"
                      v-if="isIOS"
                    >
                      <svg slot="image" class="icon" aria-hidden="true">
                        <use xlink:href="#icon-ios1"></use>
                      </svg>
                      App Store <em v-show="!appStoreUrl">(Reviewing)</em>
                    </a>-->
          <!--          <a
                      :href="TFLink ? TFLink : 'javascript:return false;'"
                      target="_blank"
                      class="button"
                      :class="{ disabledBtn: !TFLink }"
                      v-if="isIOS"
                    >
                      <svg slot="image" class="icon" aria-hidden="true">
                        <use xlink:href="#icon-ios1"></use>
                      </svg>
                      TestFlight <em v-show="!TFLink">(Reviewing)</em>
                    </a>-->
          <!--          <a
                      :href="androidApk ? androidApk : 'javascript:return false;'"
                      target="_blank"
                      class="button"
                      :class="{ disabledBtn: !androidApk }"
                      v-if="!isIOS"
                    >
                      <svg slot="image" class="icon" aria-hidden="true">
                        <use xlink:href="#icon-anzhuo3"></use>
                      </svg>
                      Android APK <em v-show="!androidApk">(Reviewing)</em>
                    </a>-->
          <!--          <a
                      :href="googlePlayUrl ? googlePlayUrl : 'javascript:return false;'"
                      target="_blank"
                      class="button"
                      :class="{ disabledBtn: !googlePlayUrl }"
                      v-if="!isIOS"
                    >
                      <svg slot="image" class="icon" aria-hidden="true">
                        <use xlink:href="#icon-guge2"></use>
                      </svg>
                      Google Play <em v-show="!googlePlayUrl">(Reviewing)</em>
                    </a>-->
        </div>
      </div>
      <div>
        <div class="title google-title">Google/Microsoft Auth</div>
        <div class="title-tip">
          Google/Microsoft authenticator generates 2-Step verification codes.
          Increase your account safety by downloading the SuperEx authenticator
          for a second step of verification.
        </div>
        <a
          class="link"
          href="https://apps.apple.com/us/app/google-authenticator/id388497605"
          target="_blank"
          v-if="isIOS"
        >Download Google Auth</a
        >
        <a
          class="link"
          href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"
          target="_blank"
          v-if="isIOS"
        >Download Microsoft Auth</a
        >
        <a
          class="link"
          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
          target="_blank"
          v-if="!isIOS"
        >Download Google Auth</a
        >
        <a
          class="link"
          href="https://play.google.com/store/apps/details?id=com.azure.authenticator"
          target="_blank"
          v-if="!isIOS"
        >Download Microsoft Auth</a
        >
      </div>
      <p class="slogan">
        Every trade you make is fuel for humans to fly into space
      </p>
    </div>
    <div class="isWecth" v-if="isWecth">
      <div class="jiantouImg">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-xiazaiyindao"></use>
        </svg>
      </div>
      <p class="wenzi">Please click [...] to open it in the browser</p>
    </div>
  </div>
</template>

<script>
import * as configs from "@/../config/config"
import { versionsApi } from "../api/user";
import { mapGetters } from "vuex";
import { languageArr, languageName } from '@/utils/utilsType'
import { setCookie,getCookie } from '@/utils/auth'
import {Button} from "vant";

export default {
  name: "download",
  components: {
    vanButton:Button
  },
  data() {
    return {
      staticState: configs[configs.Edition].staticState,
      isWecth: false,
      appStoreUrl: '',
      googlePlayUrl: '',
      androidApk: '',
      TFLink: '',
      isIOS: true,
    }
  },
  computed: {
    ...mapGetters(['isDirection'])
  },
  methods: {
    handleClick(url) {
      if (!url) {
        return false
      }else {
        window.open(url)
      }
    },
    change_language(){
      let paramsName = this.$route.query.language
      const language = getCookie('language')||'en'
      if(paramsName!=language){
        let invitationCode = sessionStorage.getItem('invitationCode') ? `&invitationCode=${sessionStorage.getItem('invitationCode')}` : '';
        if(languageArr.indexOf(paramsName)!==-1){
          setCookie('language',paramsName)
          this.$store.dispatch('setLanguageName',languageName[paramsName])
          setCookie('languageName', languageName[paramsName])
          document.documentElement.setAttribute('lang', paramsName)
          setTimeout(() => {
            this.$i18n.locale = paramsName
          }, 500)
          this.$router.replace(`/download?language=${paramsName}${invitationCode}`)
        }else{
          this.$router.replace(`/download?language=${language}${invitationCode}`)
        }
      }
    },
    getVersionsApi() {
      versionsApi().then(res => {
        if (res.code == '200' && res.data.length > 0) {
          const invitationCode = this.$route.query && this.$route.query.invitationCode ? `?invitationCode=${this.$route.query.invitationCode}` : ''
          if (this.isIOS) {
            this.TFLink = res.data.find(v => v.client == '2').extraLink ? res.data.find(v => v.client == '2').extraLink + invitationCode : ''
            if (this.$route.query.type == 'index') {
              this.appStoreUrl = 'https://superex.onelink.me/Rryx/9mo682sj'
              return
            }
            if (this.$route.query.type == 'purchase') {
              this.appStoreUrl = 'https://superex.onelink.me/Rryx/9g6pzzma'
              return
            }
            if (this.$route.query.type == 'detail') {
              this.appStoreUrl = 'https://superex.onelink.me/Rryx/vwahm4jh'
              return
            }
            this.appStoreUrl = res.data.find(v => v.client == '2').link ? res.data.find(v => v.client == '2').link + invitationCode : ''
          } else {
            this.androidApk = res.data.find(v => v.client == '3').extraLink || ''
            if (this.$route.query.type == 'index') {
              this.googlePlayUrl = 'https://superex.onelink.me/Rryx/9mo682sj'
              return
            }
            if (this.$route.query.type == 'purchase') {
              this.googlePlayUrl = 'https://superex.onelink.me/Rryx/9g6pzzma'
              return
            }
            if (this.$route.query.type == 'detail') {
              this.googlePlayUrl = 'https://superex.onelink.me/Rryx/vwahm4jh'
              return
            }
            this.googlePlayUrl = res.data.find(v => v.client == '3').link ? res.data.find(v => v.client == '3').link + invitationCode : ''
          }
        }
      })
    }
  },
  mounted() {
    this.getVersionsApi()
    document.body.style.overflowX = 'visible'; // 取消 overflow-x 的设置
    document.body.style.overflowY = 'visible'; // 取消 overflow-y 的设置
  },
  created() {
    this.change_language()
    window.document.documentElement.setAttribute("dir", this.IsShow() ? 'ltr' : 'ltr');
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.isWecth = true
    } else {
      this.isWecth = false
    }
    var u = navigator.userAgent, app = navigator.appVersion;
    // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  }
}
</script>


<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";

// body{
//     overflow-x: visible !important;
//     overflow-y: visible !important;
// }

.mobile-download {
  /*background: url("#{$variableName}static/images/mobile/download_bg.png") no-repeat center;*/
  //   background: url("../../static/images/download_bg.png") no-repeat center;
  background: url("../../static/images/download-newBg.jpg") no-repeat center;
  background-size: cover;
  width: 100%;
  height: torem(1579);
  padding: torem(51.5) torem(38) 0 torem(38);
  position: relative;

  .logo {
    @include wh(torem(107.5), torem(19));

    svg {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .title {
    @include sc(torem(24.5), #fff);
    margin-top: torem(40);
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: torem(34);
  }

  .google-title {
    @include sc(torem(21), #fff);
    margin-top: torem(649);
    text-transform: capitalize;
  }

  .title-tip {
    @include sc(torem(12), #fff);
    line-height: torem(18);
    margin: 0 0 torem(24) 0;
    word-break: break-word;

    p:first-child {
      @include sc(torem(16), #fff);
      margin-bottom: torem(15);
    }

    p {
      margin-bottom: torem(8);
    }
  }
  /deep/ .van-button--default{
    border: none;
  }
  /deep/ .van-button--disabled{
    opacity: 1;
  }
  .fotterBotton .button {
    width: 100%;
    height: torem(44);
    margin-top: torem(16);
    @include sc(torem(16), #333333);
    border-radius: torem(4);
    background: #f1b90a;
    text-align: center;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    svg {
      @include wh(torem(24), torem(28));
      margin-right: torem(5);
    }

    em {
      position: absolute;
      @include sc(torem(11), #bd8714);
      font-weight: normal;
      margin-left: torem(3.5);
      margin-top: torem(3);
      right: torem(8);
      top: torem(15);
    }
  }

  .fotterBotton .button .iconfont {
    font-size: torem(16);
    margin-right: torem(4);
  }

  .slogan {
    padding-right: torem(38);
    position: absolute;
    @include sc(torem(13), rgba(255, 255, 255, 0.5));
    text-align: center;
    line-height: 1.5;
    bottom: torem(58.5);
  }
}

a.link {
  display: block;
  @include sc(torem(13), #f1b90a);
  line-height: 1.2;
  border-bottom: torem(0.5) dashed #f1b90a;
  width: max-content;
  margin-bottom: torem(15.5);

  &:last-child {
    margin-bottom: 0;
  }
}

.isWecth {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.6);

  .jiantouImg {
    svg {
      @include wh(torem(80), torem(80));
      position: absolute;
      right: torem(20);
      top: torem(10);
    }
  }

  .wenzi {
    position: absolute;
    color: #fff;
    font-size: torem(16);
    text-align: center;
    line-height: 1.5;
    top: torem(90);
    left: torem(10);
  }
}
</style>



// WEBPACK FOOTER //
// src/view/download.vue